module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "disclaimer"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "pg_7"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SPECIAL THANKS TO")]), _vm._v(" :")])])]), _c('a', {
    attrs: {
      "id": "pg_7"
    }
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Marlene Stringer and Barbara Bova"), _c('br'), _vm._v("Tom Doherty and Paul Stevens"), _c('br'), _vm._v("Jason and Jeremy"), _c('br'), _vm._v("Grace West"), _c('br'), _vm._v("and Valette, Jake and Charlie")])])]), _c('a', {
    attrs: {
      "id": "pg_7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-661c0fe6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/disclaimer.vue
// module id = 75
// module chunks = 0